import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Heading,
  Icon,
  Image,
  Link,
  List,
  ListItem,
  Spinner,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaArrowRight, FaCalendarAlt, FaPallet, FaRobot } from "react-icons/fa";
import { isWorkspaceOwner } from "../../_utils/common";
import {
  includedFeatures,
  UPGRADE_PLAN_IMAGE_LINK,
} from "../../_utils/constants";
import { useHistory } from "react-router-dom";
import { MY_ACCOUNT } from "../../_utils/routes";
import { useSelector } from "react-redux";
import TldrVideoInAction from "../../TldrAi/TldrVideoInAction";

function TldrUpgradeTrialEndedSummary({
  onClose,
  setUpgradePlanStep,
  subscribeToFreePlan,
  currentMember,
  currentOrg,
  loading,
  video,
}) {
  const { t } = useTranslation(["accounts", "billing"]);
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const isMobileView = useSelector((state) => state.app.isMobileView);

  return (
    <Flex direction={["column", "column", "column", "row"]}>
      <Flex
        justifyContent="center"
        alignItems="center"
        width={["100%", "100%", "100%", "330px"]}
        position="relative"
        minHeight={["32"]}
      >
        {video && (
          <Box position="relative" width="100%" zIndex="2" textAlign="center">
            <TldrVideoInAction videoInAction={video} showPlayIcon />
          </Box>
        )}
        <Image
          src={UPGRADE_PLAN_IMAGE_LINK}
          alt=""
          role="presentation"
          position="absolute"
          width="100%"
          height="100%"
          objectFit="cover"
          zIndex="1"
          top="0"
        />
      </Flex>
      <Flex flex={1} minH="500px">
        <Box>
          <Box
            px="10"
            pt="6"
            pb="6"
            h={isMobileView ? "528px" : "428px"}
            display={"flex"}
            flexDir="column"
          >
            <>
              <Heading size="md" mb="3" color="white">
                {t("full_access_end")}
              </Heading>
              <Text mb="8" color="gray.100" fontSize="sm">
                {t("full_access_end_description")}&nbsp;
              </Text>
              <List spacing="4" mb="4">
                <ListItem>
                  <Flex>
                    <Icon
                      as={FaPallet}
                      color="brand.primary"
                      fontSize="2xl"
                      mr="3"
                    />
                    <Box>
                      <Heading
                        size="md"
                        fontSize="md"
                        mb="1"
                        as="h3"
                        color="white"
                      >
                        {t("full_access_feature_1")}
                      </Heading>
                      <Text color="gray.100" fontSize="sm">
                        {t("full_access_description_1")}
                      </Text>
                    </Box>
                  </Flex>
                </ListItem>
                <ListItem>
                  <Flex>
                    <Icon
                      as={FaRobot}
                      color="brand.primary"
                      fontSize="2xl"
                      mr="3"
                    />
                    <Box>
                      <Heading
                        size="md"
                        fontSize="md"
                        mb="1"
                        as="h3"
                        color="white"
                      >
                        {t("full_access_feature_2")}
                      </Heading>
                      <Text color="gray.100" fontSize="sm">
                        {t("full_access_description_2")}
                      </Text>
                    </Box>
                  </Flex>
                </ListItem>
                <ListItem>
                  <Flex>
                    <Icon
                      as={FaCalendarAlt}
                      color="brand.primary"
                      fontSize="2xl"
                      mr="3"
                    />
                    <Box>
                      <Heading
                        size="md"
                        fontSize="md"
                        mb="1"
                        as="h3"
                        color="white"
                      >
                        {t("full_access_feature_3")}
                      </Heading>
                      <Text color="gray.100" fontSize="sm">
                        {t("full_access_description_3")}
                      </Text>
                    </Box>
                  </Flex>
                </ListItem>
              </List>
            </>
          </Box>
          {isWorkspaceOwner(auth.payload.user) ? (
            <Box p={4}>
              {loading ? (
                <Flex>
                  <Spinner size={"sm"} color="gray.300" />
                  <Text ml={2} fontSize="0.875rem" color="gray.300">
                    {t("subscription_in_progress")}
                  </Text>
                </Flex>
              ) : (
                <ButtonGroup spacing="3" justifyContent="flex-end" w="full">
                  <Tooltip
                    shouldWrapChildren
                    hasArrow
                    placement="bottom"
                    label={
                      currentOrg?.members_count > 1
                        ? t("free_plan_info")
                        : !currentMember?.is_admin && !currentMember?.is_primary
                        ? t("switch_account")
                        : null
                    }
                  >
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        subscribeToFreePlan();
                      }}
                      variant="ghost"
                      color="gray.100"
                      isDisabled={
                        currentOrg?.members_count > 1 ||
                        (!currentMember?.is_admin && !currentMember?.is_primary)
                      }
                    >
                      {t("continue_free_plan")}
                    </Button>
                  </Tooltip>
                  <Button
                    variant="solid"
                    rightIcon={<FaArrowRight />}
                    onClick={() => setUpgradePlanStep((prev) => prev + 1)}
                  >
                    {t("choose_plan")}
                  </Button>
                </ButtonGroup>
              )}
            </Box>
          ) : (
            <Flex p={4} align="center" h="72px">
              <Box>
                <Text fontSize={"md"} fontWeight={500} color={"brand.negative"}>
                  {t("not_authorized")}
                </Text>
              </Box>
              <Box>
                <Button onClick={() => history.push(MY_ACCOUNT)}>
                  {t("goto_account")}
                </Button>
              </Box>
            </Flex>
          )}
        </Box>
      </Flex>
    </Flex>
  );
}

export default TldrUpgradeTrialEndedSummary;
